<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import store from '../../../../store';
import i18n from '../../../../i18n';
import TwTitleBar from '../../../../components/TwTitleBar';

export default {
  name: 'SkiRental',
  props: {
    bookingId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      currentBookingId: this.bookingId,
      activeTab: `/booking/${this.bookingId}/ski/rental/overview`,
      tabs: [
        {
          id: 1,
          name: i18n.t('ski.rental.tabHeaders.overview'),
          route: '/booking/:bookingId/ski/rental/overview',
          total: 0,
          showTotal: true,
          disabled: false,
        },
        {
          id: 2,
          name: i18n.t('ski.rental.tabHeaders.availableProducts'),
          route: '/booking/:bookingId/ski/rental/available-products',
          total: 0,
          showTotal: false,
          disabled: false,
        },
        {
          id: 3,
          name: 'Add pickup places',
          route: '/booking/:bookingId/ski/rental/pickup-places',
          showTotal: false,
          disabled: false,
        },
      ],
    };
  },
  components: {
    TwTitleBar,
  },
  computed: {
    ...mapGetters({
      totalNumberOfSkiRentalProducts: 'skirental/getTotalNumberOfSkiRentalProducts',
    }),
    ...mapState({
      booking: state => state.booking.booking,
      rentals: state => state.skirental.rentals.items,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.booking.pages.ski.title'), to: '', disabled: true },
        { text: this.$t('menu.booking.pages.ski.rental.title'), to: { name: 'SkiRentalOverview' } },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ];
    },
    rentalMenu() {
      const tabs = this.tabs;
      if (!this.currentBookingId) {
        return tabs;
      }
      const selectedBooking = this.booking;
      if (selectedBooking) {
        for (let i = 0; i < tabs.length; i += 1) {
          tabs[i].disabled = false;
          tabs[i].route = tabs[i].route.replace(':bookingId', this.currentBookingId);
          if (tabs[i].id === 1) {
            tabs[i].total = this.totalNumberOfSkiRentalProducts;
          }
        }
      }

      return tabs;
    },
  },
  methods: {
    ...mapActions({
      loadBookingStayParticipantsByStayIds: 'booking/bookingStayParticipantsByBookingStayIds',
    }),
  },
  mounted() {
    if (this.booking !== undefined && this.booking.id) {
      const bookingStayIds = this.booking.stays.map(stay => stay.id);
      this.loadBookingStayParticipantsByStayIds(bookingStayIds);
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.bookingId) {
      store.dispatch('skirental/rentalProductsByBookingIdLoad', to.params.bookingId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container v-if="booking && booking.id" fluid>
    <tw-title-bar
      :title="$t('menu.booking.titleWithArea')"
      :breadcrumbs="breadcrumbs"
      :booking-info="booking"
    >
    </tw-title-bar>
    <v-layout class="pt-0" row wrap>
      <v-flex class="pr-12" grow>
        <v-tabs v-model="activeTab"
          mandatory
          align-with-title
          grow
          fixed-tabs
        >
          <v-tab
            v-for="tab in rentalMenu"
            v-bind="tab"
            :key="tab.id"
            :to="{ path: tab.route }"
            :disabled="tab.disabled"
            exact
          >
            {{ tab.name }}
            <span v-if="tab.showTotal">
              &nbsp;({{ tab.total }})
            </span>
          </v-tab>
          <v-tabs-items>
            <v-tab-item
              v-for="tab of tabs"
              :transition="false"
              :reverse-transition="false"
              :key="tab.id"
              :value="tab.route"
            >
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/ski/rental/SkiRental.vue